export default "__VITE_ASSET__BlhzbQsV__"